import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useContentLanguages } from "@common/composable/useMetaDataStore";

import { AttributeDataType } from "@medapro-types/common/common-enum";
import { Branch, Leaf, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import { ArticleMediaAssets } from "@medapro-types/ContentEditor/content-editor-store";

import mediaAssetsApi from "@services/mediaAssets.js";

import { computed } from "vue";

import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'MediaAssetValueSelectionModal',
  props: {
    value: { type: Boolean },
    selectedEntryId: {}
  },
  emits: ["confirm", "cancel", "close", "input", "hide"],
  setup(__props: any, { emit: emits }) {

const props = __props;




//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  emits("confirm", event);
};

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods
const getNoBranches = async (): Promise<Branch[]> => {
  return [];
};

const getMediaAssetValues = async (): Promise<Leaf[]> => {
  const fetched: Array<Record<string, ArticleMediaAssets>> = await mediaAssetsApi.get([primaryLanguageCode.value], "Article");

  return fetched.map((x) => ({
    id: x[primaryLanguageCode.value].mediaAssetId,
    name: x[primaryLanguageCode.value].mediaAssetName,
    dataType: AttributeDataType.AttributeDataTypeAlphanumerical,
    icon: "MediaAsset"
  }));
};
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiLevelNavigationModal, {
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    "modal-title": _ctx.$t('selectMediaAssetValue'),
    "fetch-branches": getNoBranches,
    "fetch-leaves": getMediaAssetValues,
    "selectable-type": ['leaf'],
    "selected-entry-id": _ctx.selectedEntryId,
    "base-path-title": _ctx.$t('media.assets'),
    "with-all": "",
    onConfirm: onConfirm,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (emits('hide'))),
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel'))),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
  }, null, 8, ["modelValue", "modal-title", "selected-entry-id", "base-path-title"]))
}
}

})